export default __webpack_public_path__ + "static/media/step2.165b36a5.png";